import { render, staticRenderFns } from "./PopupInfoNewVer.vue?vue&type=template&id=98cdb290"
import script from "./PopupInfoNewVer.vue?vue&type=script&lang=js"
export * from "./PopupInfoNewVer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports